import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import PassOn from '../pages/PassOn';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pass-on" element={<PassOn />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default AppRoutes;